let signupRef: string | undefined;

/**
 * A random reference made once per page load, sent with the browser `signup` event and with `onAppStart`, so the
 * browser and server signup events can be matched without a user id. `undefined` where `crypto.randomUUID` is
 * missing (outside a secure context, Safari before 15.4): the signup is then sent unkeyed.
 */
export const getSignupRef = () => {
    if (typeof globalThis.crypto?.randomUUID === 'function') {
        signupRef ??= globalThis.crypto.randomUUID();
    }
    return signupRef;
};
